<template>
  <div class="page" :class="{ scrollable }">
    <Error v-if="toggle" :header="false" />
    <template v-else>
      <PageHeader :title="title" :showBack="showBack" @back="onBack">
        <!-- @slot ヘッダーに表示するボタンなど -->
        <slot name="header" />
      </PageHeader>
      <div class="main">
        <!-- @slot コンテンツエリアの書き換え -->
        <slot name="contents">
          <div class="contents" :style="`grid-gap: ${gap}px`">
            <slot />
          </div>
        </slot>
      </div>
      <LoadingIndicator v-if="loading" />
    </template>
  </div>
</template>

<script>
import PageHeader from '@/components/molecules/PageHeader'
import LoadingIndicator from '@/components/molecules/LoadingIndicator'
import Error from '@/views/Error'

/**
 * 設定画面のテンプレート
 */
export default {
  name: 'ConfigPage',
  components: {
    PageHeader,
    LoadingIndicator,
    Error,
  },
  props: {
    /** タイトル */
    title: String,
    /** 戻るボタンの表示 */
    showBack: Boolean,
    /** ロード中の表示 */
    loading: Boolean,
    /** grid-gap */
    gap: { type: Number, default: 16 },
    /** スクロール可能 */
    scrollable: { type: Boolean, default: false },
    /** featureToggle */
    toggle: { type: Boolean, default: false },
  },
  methods: {
    onBack() {
      /** @event back 戻るボタンのクリック */
      this.$emit('back')
    },
  },
}
</script>

<style lang="postcss" scoped>
.page {
  background: var(--very-light-gray-4);
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.main {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  padding: 32px;
}

.contents {
  align-content: flex-start;
  display: grid;
  overflow: hidden;
}

.scrollable {
  & .main {
    overflow: auto;
  }

  & .contents {
    overflow: initial;
  }
}
</style>
